<script>
export default {
  props: {
    value: { type: Array },
    items: {
      type: Array
    }
  },
  computed: {
    selectedAll() {
      return this.value.length === this.items.length
    },
    selectedSome() {
      return this.value.length > 0 && !this.selectedAll
    },
    icon() {
      if (this.selectedAll) return 'mdi-close-box'
      if (this.selectedSome) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.selectedAll) {
          this.$emit('input', [])
        } else {
          this.$emit('input', this.items.slice())
        }
      })
    }
  }
}
</script>
<template>
  <v-select
    v-if="items.find(costCenter => costCenter != '')"
    :value="value"
    :items="items"
    :label="$t('component.documentValidation.documentValidationCostCenterFilter.cost.center')"
    chips
    small-chips
    multiple
    deletable-chips
    hide-details
    @change="$emit('input', $event)">
    <template #prepend-item>
      <v-list-item ripple @mousedown.prevent @click="toggle">
        <v-list-item-action>
          <v-icon :color="value.length > 0 ? 'primary' : ''">
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
              $t('component.documentValidation.documentValidationCostCenterFilter.cost.center.select.all')
            }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>
  </v-select>
</template>
